import { Button, Link } from '@cluey/cluey-components';

import checkIcon from '../../../../../assets/images/atoms-icon-filled-alert-tick.svg';
import { SessionDateSummary } from '../../../../../components/EnrolmentManagement/SessionDateSummary';
import { STUDENT_SESSION_TYPE_KEYS } from '../../../../../types/hubEnums';
import type { Session, SessionPolicy } from '../../../../../types/hubInterfaces';
import { getRescheduleSessionRoute } from '../../../../../util/helper';

const SessionSummary = ({
  sessionPolicy,
  sessionToSkip,
  skipFailed,
  onSkipConfirm,
  isOneOffRescheduled,
}: {
  sessionPolicy: SessionPolicy;
  sessionToSkip: Session;
  skipFailed: boolean;
  onSkipConfirm(): void;
  isOneOffRescheduled?: boolean;
}) => {
  return (
    <div className="flex flex-col justify-between rounded-2xl border border-grey-2 bg-white sm:flex-row">
      <div className="rounded-l-2xl px-6 py-7 lg:px-14 lg:py-12">
        <SessionDateSummary
          heading="Cancel session"
          sessionStartDate={sessionToSkip?.startTime}
          sessionEndDate={sessionToSkip?.endTime}
          isOneOffRescheduled={isOneOffRescheduled}
        />
        <Button className="mt-8 h-10" disabled={skipFailed} onClick={onSkipConfirm} size="sm">
          Confirm cancel session
        </Button>
        <section className="mt-6">
          <div className="inline-flex flex-col gap-y-2">
            {sessionPolicy?.reschedule?.isAllowed &&
              sessionToSkip.studentSessionType !== STUDENT_SESSION_TYPE_KEYS.MAKE_UP && (
                <Link size="lg" className="link" to={getRescheduleSessionRoute(sessionToSkip.studentSessionId)}>
                  Reschedule session instead
                </Link>
              )}
          </div>
        </section>
      </div>
      <div className="rounded-b-2xl border-t border-grey-2 bg-brown-200 px-6 py-7 md:rounded-r-2xl md:rounded-bl-none lg:w-5/12 lg:border-l lg:border-t-0 lg:px-14 lg:py-12">
        <div className="mb-6 flex items-center border-b border-grey-2 pb-6 lg:mb-6 lg:pb-6">
          <img
            src={`${sessionToSkip.tutorPhoto}?v=1`}
            alt="tutor avatar"
            className="mr-lg-6 mr-5 h-[60px] w-[60px] rounded-full border border-grey-3"
          />
          <span className="lh-1-33 mb-1 text-lg font-semibold text-grey-6">
            Let {sessionToSkip?.tutor?.split(' ')[0]} know you can't make it
          </span>
        </div>
        <div className="text-grey-6">
          <div className="proxima-soft text-xs font-bold uppercase">Why is this important?</div>
          <div className="mt-3 flex flex-col gap-y-2">
            {[
              'Opens up their calendar',
              'Avoids tutor waiting in session',
              'Enables them to tutor another student',
            ].map((text, index) => {
              return (
                <div key={`skip-reason-${index}`} className="space-between flex items-center gap-x-2">
                  <img src={checkIcon} alt="check-icon" />
                  <div className="text-sm">{text}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionSummary;
